export default __webpack_public_path__ + "static/media/Icons__edit.8c2bfd23.svg";